import './new-shop-popup.scss'
import { FC, useEffect, useState } from "react"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { useDispatch, useSelector } from 'react-redux'
import { setNewShopDetails, setShopToEdit, updateShop } from '../../shopSlices'
interface NewShopPopupProps {
    fullCommentary:string,
    isVisible:boolean,
    setVisible:Function,
    subscriptionId:string;
    step:number;
    setStep:Function;
    shopToEditId: string;
}

const NewShopPopup : FC<NewShopPopupProps>= ({fullCommentary, isVisible,setVisible, subscriptionId, step, setStep, shopToEditId}) => {
    const user = useSelector((state: any) => state.auth.user);
    const dispatch: Function = useDispatch();
    const newShopDetails = useSelector((state: any) => state.shop.newShopDetails);
    const [name, setName] = useState(newShopDetails.name)
    const [address, setAddress] = useState(newShopDetails.address)
    const shops = useSelector((state: any) => state.shop.shops);
    const shopToEdit = shopToEditId ? shops.find((shop) => shop.id === shopToEditId) : null
    const labels = shopToEdit ? {
      okButton: 'Update',
      title: 'Edit shop',
      subtitle: 'Edit shop'
    }
    : {
      okButton: 'Continue',
      title: 'Add shop',
      subtitle: 'Add new shop'
    }
  
    const handleClick = (e) => {
      if(shopToEdit){
        dispatch(updateShop(shopToEditId, name, address, user.sub))
        dispatch(setShopToEdit(null))
      }
      else{
        dispatch(setNewShopDetails({name, address}))
        setStep(2)
      }
        setVisible(false)
    }
    const handleCancelBtn = () => {
        setVisible(false)
    }
    useEffect(() => {
      if(shopToEdit){
        setName(shopToEdit.name)
        setAddress(shopToEdit.address)
      }
    }
    , [shopToEdit])
    return (
      <>
      <div className="mask"></div>
      <div className="popup">
        <div className={`new-shop-popup ${isVisible || shopToEdit ? 'visible' : ''}`}>
          <div className="new-shop-popup__header">
            <div className="new-shop-popup__header__titles">
              <div className="new-shop-popup__header__titles__title">{labels.title}</div>
              <div className="new-shop-popup__header__titles__subtitle">{labels.subtitle}</div>
            </div>
            <Button onClick={() => setVisible(false)} icon="pi pi-times" iconPos='right' className="new-shop-popup__header__close-button" />
          </div>    
          <div className="new-shop-popup__content">
            <>
              <div className="new-shop-popup__content__title">Name of the shop</div>
              <InputText value={name} onChange={(e) => {setName(e.target.value)}} placeholder='Name' />
              <div className="new-shop-popup__content__title">Address of the shop</div>
              <InputText value={address} onChange={(e) => {setAddress(e.target.value)}} placeholder='Address'/>
            </>
          </div>
          <div className="new-shop-popup__footer">
            <Button onClick={() => handleCancelBtn()} iconPos='right' label={'Cancel'} className="new-shop-popup__footer__cancel-button" />
            <Button onClick={(e) => handleClick(e)} iconPos='right' disabled={!name || !address} label={labels.okButton} className="new-shop-popup__footer__confirm-button" />
          </div>
        </div>
      </div>
      </>
    )
}

export default NewShopPopup